module.exports = {
	LOGIN_ENABLED_ID: 'lwe_enabled',
	LOGIN_LINK_ID: 'lwe-link',
};
